module.exports = __webpack_public_path__ + "img/add-dialog-folder.4dd64811.svg";